var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "location" }, [_c("e-breadcrumbs")], 1),
    _c("h1", { staticClass: "page_title" }, [
      _vm._v(_vm._s(_vm.$t("menu.MENU09.020"))),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content_box mt10" }, [
      _c("div", { ref: "langAnchor" }),
      _c(
        "div",
        {
          staticClass: "nw-lang-float",
          style: { right: _vm.langRight + "px" },
        },
        [
          _c(
            "div",
            {
              staticClass: "nw-lang-tg",
              attrs: { role: "group", "aria-label": "상세 표기 언어 선택" },
            },
            [
              _c(
                "button",
                {
                  class: { on: _vm.dispLang === "loc" },
                  attrs: {
                    type: "button",
                    "aria-pressed": _vm.dispLang === "loc" ? "true" : "false",
                  },
                  on: {
                    click: function ($event) {
                      _vm.dispLang = "loc"
                    },
                  },
                },
                [_vm._v("LOCAL")]
              ),
              _c(
                "button",
                {
                  class: { on: _vm.dispLang === "eng" },
                  attrs: {
                    type: "button",
                    "aria-pressed": _vm.dispLang === "eng" ? "true" : "false",
                  },
                  on: {
                    click: function ($event) {
                      _vm.dispLang = "eng"
                    },
                  },
                },
                [_vm._v("ENG")]
              ),
            ]
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "network_menu" },
        _vm._l(_vm.regionRows, function (row, ri) {
          return _c(
            "div",
            { key: "rgrow" + ri, staticClass: "rg-row" },
            [
              _vm._l(row, function (rg) {
                return [
                  _c(
                    "a",
                    {
                      key: rg.name,
                      staticClass: "rg-label",
                      attrs: { href: "#" },
                      on: {
                        mouseenter: function ($event) {
                          return _vm.hoverRegion(rg)
                        },
                        mouseleave: function ($event) {
                          return _vm.hoverRegion(null)
                        },
                        focus: function ($event) {
                          return _vm.hoverRegion(rg)
                        },
                        blur: function ($event) {
                          return _vm.hoverRegion(null)
                        },
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.flyRegion(rg)
                        },
                      },
                    },
                    [_vm._v(_vm._s(rg.name))]
                  ),
                  _c(
                    "ul",
                    { key: rg.name + "-ul" },
                    _vm._l(rg.items, function (item) {
                      return _c(
                        "li",
                        {
                          key: item.seq,
                          staticClass: "list_area",
                          class: { on: _vm.ctrFlag === item.seq },
                          attrs: { id: item.seq },
                          on: {
                            mouseenter: function ($event) {
                              _vm.hoverCtr = item.seq
                            },
                            mouseleave: function ($event) {
                              _vm.hoverCtr = ""
                            },
                          },
                        },
                        [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "#",
                                "aria-current":
                                  _vm.ctrFlag === item.seq ? "true" : null,
                              },
                              on: {
                                focus: function ($event) {
                                  _vm.hoverCtr = item.seq
                                },
                                blur: function ($event) {
                                  _vm.hoverCtr = ""
                                },
                                click: function ($event) {
                                  $event.preventDefault()
                                  ;[
                                    _vm.getNetworkInfo(item.seq),
                                    _vm.btnChgImg(item.seq),
                                  ]
                                },
                              },
                            },
                            [_vm._v(_vm._s(item.name))]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              }),
            ],
            2
          )
        }),
        0
      ),
      _c(
        "div",
        { staticClass: "map_wrap network_map_wrap mt10" },
        [
          _c("network-map", {
            ref: "nwmap",
            attrs: {
              seq: _vm.ctrFlag,
              cities: _vm.mapCities,
              "hover-seq": _vm.hoverCtr,
              "hover-seqs": _vm.hoverCtrs,
            },
            on: {
              select: function ($event) {
                ;[_vm.getNetworkInfo($event), _vm.btnChgImg($event)]
              },
              hover: function ($event) {
                _vm.hoverCtr = $event
              },
              city: _vm.scrollToCity,
            },
          }),
        ],
        1
      ),
      _vm.isAdmin
        ? _c("div", { staticClass: "nw-adm-bar" }, [
            _c(
              "button",
              {
                staticClass: "nw-ebtn add big",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.openOfc(null)
                  },
                },
              },
              [_vm._v("+ 사무소 추가 (현재 국가 아래)")]
            ),
          ])
        : _vm._e(),
      _vm.portFilterOfcCds.length
        ? _c("div", { staticClass: "nw-port-filter" }, [
            _vm.serviceLang === "KOR"
              ? _c("span", [
                  _c("b", [_vm._v(_vm._s(_vm.portFilterNm))]),
                  _vm._v(
                    " 담당 사무소만 표시 중 (" +
                      _vm._s(_vm.officeList.length) +
                      "건)"
                  ),
                ])
              : _c("span", [
                  _vm._v("Showing "),
                  _c("b", [_vm._v(_vm._s(_vm.portFilterNm))]),
                  _vm._v(
                    " office(s) only (" + _vm._s(_vm.officeList.length) + ")"
                  ),
                ]),
            _c(
              "button",
              { attrs: { type: "button" }, on: { click: _vm.clearPortFilter } },
              [
                _vm._v(
                  _vm._s(_vm.serviceLang === "KOR" ? "전체 보기" : "Show all")
                ),
              ]
            ),
          ])
        : _vm._e(),
      _vm.officeList.length
        ? _c(
            "div",
            { staticClass: "nw-offices" },
            _vm._l(_vm.officeList, function (ofc, oi) {
              return _c(
                "div",
                {
                  key: ofc.ofcCd,
                  staticClass: "nw-office",
                  class: { "nw-off": _vm.isAdmin && ofc.useYn === "N" },
                  attrs: { "data-ofc-cd": ofc.ofcCd },
                },
                [
                  _c("div", { staticClass: "nw-office-h" }, [
                    _vm.isAdmin
                      ? _c("span", { staticClass: "nw-lvl l1" }, [
                          _vm._v("① 사무소"),
                        ])
                      : _vm._e(),
                    _c(
                      "span",
                      {
                        staticClass: "nw-badge",
                        class: ofc.type === "AGENCY" ? "ag" : "km",
                      },
                      [_vm._v(_vm._s(ofc.type))]
                    ),
                    _vm.isAdmin && ofc.useYn === "N"
                      ? _c("span", { staticClass: "nw-badge off" }, [
                          _vm._v("미사용"),
                        ])
                      : _vm._e(),
                    _c("b", [_vm._v(_vm._s(_vm.locName(ofc.nm, ofc.enm)))]),
                    _vm.dispLang === "loc" && ofc.enm && ofc.enm !== ofc.nm
                      ? _c("span", { staticClass: "nw-en" }, [
                          _vm._v(_vm._s(ofc.enm)),
                        ])
                      : _vm._e(),
                    _vm.isAdmin
                      ? _c("span", { staticClass: "nw-h-btns" }, [
                          _c(
                            "button",
                            {
                              staticClass: "nw-ebtn ordb",
                              attrs: {
                                type: "button",
                                title: "위로",
                                disabled: _vm.mSaving || oi === 0,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.moveOfc(oi, -1)
                                },
                              },
                            },
                            [_vm._v("▲")]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "nw-ebtn ordb",
                              attrs: {
                                type: "button",
                                title: "아래로",
                                disabled:
                                  _vm.mSaving ||
                                  oi === _vm.officeList.length - 1,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.moveOfc(oi, 1)
                                },
                              },
                            },
                            [_vm._v("▼")]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "nw-ebtn",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.openOfc(ofc)
                                },
                              },
                            },
                            [_vm._v("✎ 사무소 수정")]
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _vm.locName(ofc.addr, ofc.addrEnm)
                    ? _c("div", { staticClass: "nw-office-addr" }, [
                        _vm._v(_vm._s(_vm.locName(ofc.addr, ofc.addrEnm))),
                        ofc.tel
                          ? _c("span", [_vm._v(" · TEL " + _vm._s(ofc.tel))])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  !_vm.isAdmin
                    ? _c("table", { staticClass: "tbl_col nw-pic" }, [
                        _c("caption", { staticClass: "sr-only" }, [
                          _vm._v(
                            _vm._s(_vm.locName(ofc.nm, ofc.enm) || ofc.area) +
                              " 담당자 연락처"
                          ),
                        ]),
                        _vm._m(0, true),
                        _vm._m(1, true),
                        _c(
                          "tbody",
                          _vm._l(_vm.officeRows(ofc), function (row) {
                            return _c("tr", { key: row.key }, [
                              row.first
                                ? _c(
                                    "td",
                                    {
                                      staticClass: "nw-area-c",
                                      attrs: {
                                        rowspan: row.areaSpan,
                                        "data-area-cd": row.areaCd,
                                      },
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "nw-area-link",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openMap(ofc)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(" " + _vm._s(row.area) + " "),
                                          _c("span", {
                                            staticClass: "nw-pin",
                                            attrs: { "aria-hidden": "true" },
                                          }),
                                          _c(
                                            "span",
                                            { staticClass: "sr-only" },
                                            [_vm._v("지도에서 보기")]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c("td", { class: { "nw-c": !row.team } }, [
                                _vm._v(_vm._s(row.team || "-")),
                              ]),
                              _c("td", { class: { "nw-c": !row.job } }, [
                                _vm._v(_vm._s(row.job || "-")),
                              ]),
                              _c("td", { class: { "nw-c": !row.tel } }, [
                                _vm._v(_vm._s(row.tel || "-")),
                              ]),
                              _c("td", { class: { "nw-c": !row.email } }, [
                                row.email
                                  ? _c(
                                      "button",
                                      {
                                        staticClass: "nw-email-copy",
                                        attrs: {
                                          type: "button",
                                          title: "클릭하여 이메일 주소 복사",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.copyEmail(
                                              row.email,
                                              row.key
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(" " + _vm._s(row.email)),
                                        _vm.copiedKey === row.key
                                          ? _c(
                                              "span",
                                              { staticClass: "nw-copied" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.serviceLang === "KOR"
                                                      ? "복사됨"
                                                      : "Copied"
                                                  )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  : _c("span", [_vm._v("-")]),
                              ]),
                            ])
                          }),
                          0
                        ),
                      ])
                    : _c(
                        "div",
                        { staticClass: "nw-tree" },
                        [
                          _vm._l(ofc.areas || [], function (ar, ai) {
                            return _c(
                              "div",
                              {
                                key: ar.areaCd,
                                staticClass: "nw-node-area",
                                class: { "nw-off": ar.useYn === "N" },
                                attrs: { "data-area-cd": ar.areaCd },
                              },
                              [
                                _c("div", { staticClass: "nw-node-h" }, [
                                  _c("span", { staticClass: "nw-lvl l2" }, [
                                    _vm._v("② AREA"),
                                  ]),
                                  _c("b", [
                                    _vm._v(_vm._s(_vm.locName(ar.nm, ar.enm))),
                                  ]),
                                  ar.useYn === "N"
                                    ? _c(
                                        "span",
                                        { staticClass: "nw-badge off" },
                                        [_vm._v("미사용")]
                                      )
                                    : _vm._e(),
                                  _c("span", { staticClass: "nw-cd" }, [
                                    _vm._v(_vm._s(ar.areaCd)),
                                  ]),
                                  _c("span", { staticClass: "nw-h-btns" }, [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "nw-ebtn ordb",
                                        attrs: {
                                          type: "button",
                                          title: "위로",
                                          disabled: _vm.mSaving || ai === 0,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.moveArea(ofc, ai, -1)
                                          },
                                        },
                                      },
                                      [_vm._v("▲")]
                                    ),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "nw-ebtn ordb",
                                        attrs: {
                                          type: "button",
                                          title: "아래로",
                                          disabled:
                                            _vm.mSaving ||
                                            ai === (ofc.areas || []).length - 1,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.moveArea(ofc, ai, 1)
                                          },
                                        },
                                      },
                                      [_vm._v("▼")]
                                    ),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "nw-ebtn",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openArea(ofc, ar)
                                          },
                                        },
                                      },
                                      [_vm._v("✎ 수정")]
                                    ),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "nw-ebtn add",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openPic(ofc, ar, null)
                                          },
                                        },
                                      },
                                      [_vm._v("+ 담당자 추가 (이 AREA에)")]
                                    ),
                                  ]),
                                ]),
                                (ar.pics || []).length
                                  ? _c("table", { staticClass: "nw-pt" }, [
                                      _vm._m(2, true),
                                      _c(
                                        "tbody",
                                        _vm._l(ar.pics, function (pic, pi) {
                                          return _c(
                                            "tr",
                                            {
                                              key: pic.picCd,
                                              class: {
                                                "nw-off": pic.useYn === "N",
                                              },
                                            },
                                            [
                                              _c(
                                                "td",
                                                { staticClass: "nw-cd" },
                                                [
                                                  _vm._v(
                                                    _vm._s(pic.picCd) + " "
                                                  ),
                                                  pic.useYn === "N"
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "nw-badge off",
                                                        },
                                                        [_vm._v("미사용")]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                              _c("td", [
                                                _c(
                                                  "span",
                                                  { staticClass: "nw-lvl l3" },
                                                  [_vm._v("③")]
                                                ),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.locName(
                                                        pic.team,
                                                        pic.teamEnm
                                                      )
                                                    )
                                                ),
                                              ]),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.locName(
                                                      pic.job,
                                                      pic.jobEnm
                                                    )
                                                  )
                                                ),
                                              ]),
                                              _c("td", [
                                                _vm._v(_vm._s(pic.tel)),
                                              ]),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(pic.email || "-")
                                                ),
                                              ]),
                                              _c(
                                                "td",
                                                { staticClass: "nw-r" },
                                                [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "nw-ebtn ordb",
                                                      attrs: {
                                                        type: "button",
                                                        title: "위로",
                                                        disabled:
                                                          _vm.mSaving ||
                                                          pi === 0,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.movePic(
                                                            ar,
                                                            pi,
                                                            -1
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("▲")]
                                                  ),
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "nw-ebtn ordb",
                                                      attrs: {
                                                        type: "button",
                                                        title: "아래로",
                                                        disabled:
                                                          _vm.mSaving ||
                                                          pi ===
                                                            ar.pics.length - 1,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.movePic(
                                                            ar,
                                                            pi,
                                                            1
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("▼")]
                                                  ),
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass: "nw-ebtn",
                                                      attrs: { type: "button" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.openPic(
                                                            ofc,
                                                            ar,
                                                            pic
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("✎ 수정")]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        }),
                                        0
                                      ),
                                    ])
                                  : _c("div", { staticClass: "nw-nopic" }, [
                                      _vm._v(
                                        "담당자 없음 — 위 [+ 담당자 추가]로 등록"
                                      ),
                                    ]),
                              ]
                            )
                          }),
                          _c("div", { staticClass: "nw-addline" }, [
                            _c(
                              "button",
                              {
                                staticClass: "nw-ebtn add",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openArea(ofc, null)
                                  },
                                },
                              },
                              [_vm._v("+ AREA 추가 (이 사무소 아래)")]
                            ),
                          ]),
                        ],
                        2
                      ),
                ]
              )
            }),
            0
          )
        : _c("div", { staticClass: "nw-empty" }, [
            _vm._v("등록된 사무소 정보가 없습니다."),
          ]),
      _vm.mType
        ? _c("div", { staticClass: "nw-mbg", on: { click: _vm.closeM } })
        : _vm._e(),
      _vm.mType
        ? _c("div", { staticClass: "nw-modal" }, [
            _c("div", { staticClass: "nw-m-h" }, [
              _vm._v(_vm._s(_vm.mTitle)),
              _c(
                "button",
                {
                  staticClass: "nw-m-x",
                  attrs: { type: "button" },
                  on: { click: _vm.closeM },
                },
                [_vm._v("✕")]
              ),
            ]),
            _c("div", {
              staticClass: "nw-m-path",
              domProps: { innerHTML: _vm._s(_vm.mPath) },
            }),
            _c("div", { staticClass: "nw-m-b" }, [
              _vm.mType === "ofc"
                ? _c("div", { staticClass: "nw-frm" }, [
                    _c("label", [_vm._v("구분")]),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.mForm.cat,
                            expression: "mForm.cat",
                          },
                        ],
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.mForm,
                              "cat",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      [
                        _c("option", [_vm._v("KMTC")]),
                        _c("option", [_vm._v("AGENCY")]),
                      ]
                    ),
                    _c("label", [_vm._v("코드")]),
                    _c("input", {
                      attrs: { type: "text", disabled: "" },
                      domProps: {
                        value: _vm.mIsNew ? "(자동채번)" : _vm.mForm.ofcCd,
                      },
                    }),
                    _c("label", [_vm._v("사무소명 (현지어)")]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.mForm.nm,
                          expression: "mForm.nm",
                        },
                      ],
                      staticClass: "full",
                      attrs: { type: "text", placeholder: "예: 서울본사" },
                      domProps: { value: _vm.mForm.nm },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.mForm, "nm", $event.target.value)
                        },
                      },
                    }),
                    _c("label", [_vm._v("사무소명 (영문)")]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.mForm.enm,
                          expression: "mForm.enm",
                        },
                      ],
                      staticClass: "full",
                      attrs: {
                        type: "text",
                        placeholder: "예: KMTC Singapore Office",
                      },
                      domProps: { value: _vm.mForm.enm },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.mForm, "enm", $event.target.value)
                        },
                      },
                    }),
                    _c("label", [_vm._v("도시(AREA명)")]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.mForm.areaNm,
                          expression: "mForm.areaNm",
                        },
                      ],
                      attrs: { type: "text" },
                      domProps: { value: _vm.mForm.areaNm },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.mForm, "areaNm", $event.target.value)
                        },
                      },
                    }),
                    _c("label", [_vm._v("전화번호")]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.mForm.tel,
                          expression: "mForm.tel",
                        },
                      ],
                      attrs: { type: "text" },
                      domProps: { value: _vm.mForm.tel },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.mForm, "tel", $event.target.value)
                        },
                      },
                    }),
                    _c("label", [_vm._v("주소 (현지어)")]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.mForm.addr,
                          expression: "mForm.addr",
                        },
                      ],
                      staticClass: "full",
                      attrs: { type: "text" },
                      domProps: { value: _vm.mForm.addr },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.mForm, "addr", $event.target.value)
                        },
                      },
                    }),
                    _c("label", [_vm._v("주소 (영문)")]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.mForm.addrEnm,
                          expression: "mForm.addrEnm",
                        },
                      ],
                      staticClass: "full",
                      attrs: { type: "text" },
                      domProps: { value: _vm.mForm.addrEnm },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.mForm, "addrEnm", $event.target.value)
                        },
                      },
                    }),
                    _c("label", [_vm._v("위도")]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.mForm.lat,
                          expression: "mForm.lat",
                        },
                      ],
                      attrs: { type: "text" },
                      domProps: { value: _vm.mForm.lat },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.mForm, "lat", $event.target.value)
                        },
                      },
                    }),
                    _c("label", [_vm._v("경도")]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.mForm.lng,
                          expression: "mForm.lng",
                        },
                      ],
                      attrs: { type: "text" },
                      domProps: { value: _vm.mForm.lng },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.mForm, "lng", $event.target.value)
                        },
                      },
                    }),
                    _c("label", [_vm._v("지도 URL")]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.mForm.mapUrl,
                          expression: "mForm.mapUrl",
                        },
                      ],
                      staticClass: "full",
                      attrs: {
                        type: "text",
                        placeholder:
                          "구글맵 공유링크 — 비우면 주소로 지도 검색",
                      },
                      domProps: { value: _vm.mForm.mapUrl },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.mForm, "mapUrl", $event.target.value)
                        },
                      },
                    }),
                    _c("label", [_vm._v("옵션")]),
                    _c("span", { staticClass: "chk full" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.mForm.mapYnB,
                            expression: "mForm.mapYnB",
                          },
                        ],
                        attrs: { type: "checkbox", id: "nwMapYn" },
                        domProps: {
                          checked: Array.isArray(_vm.mForm.mapYnB)
                            ? _vm._i(_vm.mForm.mapYnB, null) > -1
                            : _vm.mForm.mapYnB,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.mForm.mapYnB,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.mForm,
                                    "mapYnB",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.mForm,
                                    "mapYnB",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.mForm, "mapYnB", $$c)
                            }
                          },
                        },
                      }),
                      _c("label", { attrs: { for: "nwMapYn" } }, [
                        _vm._v("지도에 표시"),
                      ]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.mForm.useYnB,
                            expression: "mForm.useYnB",
                          },
                        ],
                        attrs: { type: "checkbox", id: "nwOUseYn" },
                        domProps: {
                          checked: Array.isArray(_vm.mForm.useYnB)
                            ? _vm._i(_vm.mForm.useYnB, null) > -1
                            : _vm.mForm.useYnB,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.mForm.useYnB,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.mForm,
                                    "useYnB",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.mForm,
                                    "useYnB",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.mForm, "useYnB", $$c)
                            }
                          },
                        },
                      }),
                      _c("label", { attrs: { for: "nwOUseYn" } }, [
                        _vm._v("사용"),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _vm.mType === "area"
                ? _c("div", { staticClass: "nw-frm" }, [
                    _c("label", [_vm._v("코드")]),
                    _c("input", {
                      attrs: { type: "text", disabled: "" },
                      domProps: {
                        value: _vm.mIsNew ? "(자동채번)" : _vm.mForm.areaCd,
                      },
                    }),
                    _c("span"),
                    _c("span"),
                    _c("label", [_vm._v("AREA명 (현지어)")]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.mForm.nm,
                          expression: "mForm.nm",
                        },
                      ],
                      staticClass: "full",
                      attrs: { type: "text", placeholder: "예: 자카르타" },
                      domProps: { value: _vm.mForm.nm },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.mForm, "nm", $event.target.value)
                        },
                      },
                    }),
                    _c("label", [_vm._v("AREA명 (영문)")]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.mForm.enm,
                          expression: "mForm.enm",
                        },
                      ],
                      staticClass: "full",
                      attrs: { type: "text", placeholder: "예: JAKARTA" },
                      domProps: { value: _vm.mForm.enm },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.mForm, "enm", $event.target.value)
                        },
                      },
                    }),
                    _c("label", [_vm._v("옵션")]),
                    _c("span", { staticClass: "chk full" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.mForm.useYnB,
                            expression: "mForm.useYnB",
                          },
                        ],
                        attrs: { type: "checkbox", id: "nwAUseYn" },
                        domProps: {
                          checked: Array.isArray(_vm.mForm.useYnB)
                            ? _vm._i(_vm.mForm.useYnB, null) > -1
                            : _vm.mForm.useYnB,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.mForm.useYnB,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.mForm,
                                    "useYnB",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.mForm,
                                    "useYnB",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.mForm, "useYnB", $$c)
                            }
                          },
                        },
                      }),
                      _c("label", { attrs: { for: "nwAUseYn" } }, [
                        _vm._v("사용"),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _vm.mType === "pic"
                ? _c("div", { staticClass: "nw-frm" }, [
                    _c("label", [_vm._v("코드")]),
                    _c("input", {
                      attrs: { type: "text", disabled: "" },
                      domProps: {
                        value: _vm.mIsNew ? "(자동채번)" : _vm.mForm.picCd,
                      },
                    }),
                    _c("span"),
                    _c("span"),
                    _c("label", [_vm._v("팀명 (현지어)")]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.mForm.team,
                          expression: "mForm.team",
                        },
                      ],
                      staticClass: "full",
                      attrs: { type: "text", placeholder: "예: 수출영업팀" },
                      domProps: { value: _vm.mForm.team },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.mForm, "team", $event.target.value)
                        },
                      },
                    }),
                    _c("label", [_vm._v("팀명 (영문)")]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.mForm.teamEnm,
                          expression: "mForm.teamEnm",
                        },
                      ],
                      staticClass: "full",
                      attrs: {
                        type: "text",
                        placeholder: "예: Export Sales Team",
                      },
                      domProps: { value: _vm.mForm.teamEnm },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.mForm, "teamEnm", $event.target.value)
                        },
                      },
                    }),
                    _c("label", [_vm._v("JOB (현지어)")]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.mForm.job,
                          expression: "mForm.job",
                        },
                      ],
                      staticClass: "full",
                      attrs: {
                        type: "text",
                        placeholder: "예: 부킹, B/L 발행",
                      },
                      domProps: { value: _vm.mForm.job },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.mForm, "job", $event.target.value)
                        },
                      },
                    }),
                    _c("label", [_vm._v("JOB (영문)")]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.mForm.jobEnm,
                          expression: "mForm.jobEnm",
                        },
                      ],
                      staticClass: "full",
                      attrs: {
                        type: "text",
                        placeholder: "예: Booking, B/L Issue",
                      },
                      domProps: { value: _vm.mForm.jobEnm },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.mForm, "jobEnm", $event.target.value)
                        },
                      },
                    }),
                    _c("label", [_vm._v("전화번호")]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.mForm.tel,
                          expression: "mForm.tel",
                        },
                      ],
                      attrs: { type: "text" },
                      domProps: { value: _vm.mForm.tel },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.mForm, "tel", $event.target.value)
                        },
                      },
                    }),
                    _c("label", [_vm._v("이메일")]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.mForm.eml,
                          expression: "mForm.eml",
                        },
                      ],
                      attrs: { type: "text" },
                      domProps: { value: _vm.mForm.eml },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.mForm, "eml", $event.target.value)
                        },
                      },
                    }),
                    _c("label", [_vm._v("옵션")]),
                    _c("span", { staticClass: "chk full" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.mForm.useYnB,
                            expression: "mForm.useYnB",
                          },
                        ],
                        attrs: { type: "checkbox", id: "nwPUseYn" },
                        domProps: {
                          checked: Array.isArray(_vm.mForm.useYnB)
                            ? _vm._i(_vm.mForm.useYnB, null) > -1
                            : _vm.mForm.useYnB,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.mForm.useYnB,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.mForm,
                                    "useYnB",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.mForm,
                                    "useYnB",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.mForm, "useYnB", $$c)
                            }
                          },
                        },
                      }),
                      _c("label", { attrs: { for: "nwPUseYn" } }, [
                        _vm._v("사용"),
                      ]),
                    ]),
                  ])
                : _vm._e(),
            ]),
            _c("div", { staticClass: "nw-m-f" }, [
              !_vm.mIsNew
                ? _c(
                    "button",
                    {
                      staticClass: "nw-btn danger",
                      attrs: { type: "button", disabled: _vm.mSaving },
                      on: { click: _vm.delM },
                    },
                    [_vm._v("🗑 삭제")]
                  )
                : _vm._e(),
              _c("span", { staticClass: "sp" }),
              _c(
                "button",
                {
                  staticClass: "nw-btn ghost",
                  attrs: { type: "button", disabled: _vm.mSaving },
                  on: { click: _vm.closeM },
                },
                [_vm._v("취소")]
              ),
              _c(
                "button",
                {
                  staticClass: "nw-btn save",
                  attrs: { type: "button", disabled: _vm.mSaving },
                  on: { click: _vm.saveM },
                },
                [_vm._v(_vm._s(_vm.mSaving ? "저장 중…" : "저장"))]
              ),
            ]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { attrs: { width: "18%" } }),
      _c("col", { attrs: { width: "24%" } }),
      _c("col", { attrs: { width: "26%" } }),
      _c("col", { attrs: { width: "16%" } }),
      _c("col", { attrs: { width: "16%" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { scope: "col" } }, [_vm._v("AREA")]),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("TEAM / NAME")]),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("JOB")]),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("OFFICE TEL.")]),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("EMAIL")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { staticStyle: { width: "96px" }, attrs: { scope: "col" } }, [
          _vm._v("코드"),
        ]),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("팀")]),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("JOB")]),
        _c("th", { staticStyle: { width: "130px" }, attrs: { scope: "col" } }, [
          _vm._v("전화"),
        ]),
        _c("th", { staticStyle: { width: "140px" }, attrs: { scope: "col" } }, [
          _vm._v("이메일"),
        ]),
        _c("th", { staticStyle: { width: "80px" }, attrs: { scope: "col" } }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }